export default {
    ca: {
        copiar: "Copiar",
        tevaGaleria: "Enllaç a la teva galeria",
    },
    es: {
        copiar: "Copiar",
        tevaGaleria: "Enlace a tu galería",
    },
    en: {
        copiar: "Copy",
        tevaGaleria: "Link to your gallery",
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/perfil-featured/perfil-featured-translations.js